import React, { useEffect, useState } from 'react'
import { useModel, useSelector } from 'umi'
import { Select, Button, message as $message } from 'antd'
import CustomIcon from '@/components/CustomIcon'
import { countOrdersBelowControlPrice } from '@/services/order'
import styles from './index.less'

const dayOptions = [
    {
        label: '近3日',
        value: 3
    },
    {
        label: '近7日',
        value: 7
    },
    {
        label: '近15日',
        value: 15
    },
    {
        label: '近30日',
        value: 30
    }
]

const Query = () => {
    const { query, search, setQuery } = useModel('useBreakPriceDrawer')
    const [coOptions, setCoOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const UNDERPRICED_ORDER_WHITELIST = useSelector(state => state.menu.userMenuWhiteList.UNDERPRICED_ORDER_WHITELIST)

    useEffect(() => {
        if (UNDERPRICED_ORDER_WHITELIST && dayOptions.length === 4) {
            dayOptions.unshift({
                label: '今日',
                value: 1
            })
        }
    }, [UNDERPRICED_ORDER_WHITELIST, dayOptions.length])

    const handleOptionClick = option => {
        search({
            ...query,
            day: option.value
        })
    }

    const handleCoChange = newValue => {
        setQuery({
            ...query,
            co: newValue
        })
    }

    const handleSearch = () => {
        search()
    }

    useEffect(() => {
        setLoading(true)
        const dataDayRangeMap = {
            1: 'TODAY',
            3: 'NEARLY_THREE_DAY',
            7: 'NEARLY_SEVEN_DAY',
            15: 'NEARLY_FIFTEEN_DAY',
            30: 'NEARLY_THIRTY_DAY'
        }
        countOrdersBelowControlPrice({ dataDayRange: dataDayRangeMap[query.day] })
            .then(response => {
                const { success, message, data } = response ?? {}
                if (!success) {
                    $message.error(message)
                    return
                }
                setCoOptions(
                    (data?.orderCounts || []).map(_ => ({
                        label: _.channelName,
                        value: _.channelCoId
                    }))
                )
            })
            .finally(() => {
                setLoading(false)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query.day])

    return (
        <div className={styles.query}>
            {dayOptions.map(_ => (
                <div
                    key={_.value}
                    className={`${styles.option} ${query.day === _.value ? styles.optionActive : ''}`}
                    onClick={() => handleOptionClick(_)}
                >
                    {_.label}
                    {query.day === _.value && <CustomIcon className={styles.checkIcon} type="icon-check-line" />}
                </div>
            ))}
            <div className={styles.label}>{query.day === 1 ? '今日' : `近${query.day}日`}有破价分销商</div>
            <Select
                className={styles.select}
                value={query.co}
                options={coOptions}
                loading={loading}
                labelInValue
                onChange={handleCoChange}
            />
            <Button className={styles.btn} type="primary" onClick={handleSearch}>
                搜索
            </Button>
        </div>
    )
}

export default Query
